<h3 class="title-divider">{{ heading | translate }}</h3>
<cap-form-control labelKey="Liegenschaft">
  <input
    (ngModelChange)="model && (model.sucheLig = $event)"
    [ngModel]="model && model.sucheLig"
    name="grunstueckTypAuswahl.sucheLiegebnschaft"
    type="checkbox" />
</cap-form-control>
<cap-form-control labelKey="SelbststaendigesUndDauerndesRechtMitAbkuerzung">
  <input
    (ngModelChange)="model && (model.sucheSdr = $event)"
    [ngModel]="model && model.sucheSdr"
    name="grunstueckTypAuswahl.sucheSdr"
    type="checkbox" />
</cap-form-control>
<cap-form-row column-classes="col-md-5 pt-14">
  <cap-form-control labelKey="Unterart">
    <select (ngModelChange)="model && (model.sucheSdrUnterart = $event)" [ngModel]="model && model.sucheSdrUnterart" name="unterart">
      @for (o of sdrUnterartArray; track o) {
        <option value="{{ o }}">{{ getUnterart(o) }}</option>
      }
    </select>
  </cap-form-control>
</cap-form-row>
@if (stwSucheMoeglich) {
  <cap-form-control labelKey="Stockwerkeigentum">
    <input
      (ngModelChange)="model && (model.sucheStw = $event)"
      [ngModel]="model && model.sucheStw"
      name="grunstueckTypAuswahl.sucheStockwerkeigentum"
      type="checkbox" />
  </cap-form-control>
}
@if (mitSucheMoeglich) {
  <cap-form-control labelKey="Miteigentumsanteil">
    <input
      (ngModelChange)="model && (model.sucheMit = $event)"
      [ngModel]="model && model.sucheMit"
      name="grunstueckTypAuswahl.sucheMiteigentum"
      type="checkbox" />
  </cap-form-control>
}
@if (folioSucheMoeglich) {
  <cap-form-control labelKey="Folio">
    <input
      (ngModelChange)="model && (model.sucheFolio = $event)"
      [ngModel]="model && model.sucheFolio"
      name="grundstueckTypAuswahl.sucheFolio"
      type="checkbox" />
  </cap-form-control>
}
